import styled, { keyframes } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui, greyMui, redMui, rydeColors } from "@ryde/theme";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
`;

export const PRODUCTION_CHAIN_STATUS_COLORS = {
  created: greyMui._400,
  next: greyMui._600,
  inProgress: rydeColors.venetianNights,
  finished: rydeColors.thujaGreen,
  emptyFinished: rydeColors.lightThujaGreen,
  failed: redMui._500,
} as const;

export const ProductionChainsStatusBarStyled = styled.nav.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "production-chains-status-bar",
  },
)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 0;
  margin-block-end: 8px;

  .chain-step {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    padding: 0 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    border: 2px solid transparent;
    transition:
      transform 0.15s ease,
      border-color 0.15s ease;

    &:hover {
      transform: scale(1.05);
    }

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui._300};
      outline-offset: 2px;
    }
  }

  .chain-step--created {
    background-color: ${PRODUCTION_CHAIN_STATUS_COLORS.created};
  }

  .chain-step--next {
    background-color: ${PRODUCTION_CHAIN_STATUS_COLORS.next};

    @media (prefers-reduced-motion: no-preference) {
      animation: ${pulse} 1.5s ease-in-out infinite;
    }
  }

  .chain-step--in-progress {
    background-color: ${PRODUCTION_CHAIN_STATUS_COLORS.inProgress};

    @media (prefers-reduced-motion: no-preference) {
      animation: ${pulse} 1.5s ease-in-out infinite;
    }
  }

  .chain-step--finished {
    background-color: ${PRODUCTION_CHAIN_STATUS_COLORS.finished};
  }

  .chain-step--empty-finished {
    background-color: ${PRODUCTION_CHAIN_STATUS_COLORS.emptyFinished};
  }

  .chain-step--failed {
    background-color: ${PRODUCTION_CHAIN_STATUS_COLORS.failed};
  }

  .chain-step--active {
    border-color: ${rydeColors.black};
  }

  .chain-connector {
    width: 12px;
    height: 2px;
    background-color: ${greyMui._300};
    flex-shrink: 0;
  }
`;
